<template>
  <validation-observer ref="AddForm" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted()">
      <b-row>
        <b-col md="12">
          <b-form-group label="Name" label-for="Name">
            <validation-provider #default="{ errors }" name="Name" vid="Name" rules="required">
              <b-form-input id="milestone_title" placeholder="Title" required v-model="milestone.name" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Description" label-for="milestone_description">
            <validation-provider #default="{ errors }" name="Description" vid="Description" rules="required">
              <b-form-textarea id="milestone_description" placeholder="Description" rows="3"
                v-model="milestone.description" />
                <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </b-col>
        <b-col md="6">
          <b-form-group label="Start Date" label-for="start_date">
            <validation-provider #default="{ errors }" name="Start Date" vid="start_date" rules="required">
            <b-form-datepicker id="start_date" placeholder="Choose a date"
              v-model="milestone.startDate" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="End Date" label-for="end_date">
            <validation-provider #default="{ errors }" name="End Date" vid="end_date" rules="required">
            <b-form-datepicker id="end_date" :min="milestone.startDate || currentDate" placeholder="Choose a date" local="en" initial-date="2024-06-16"
              v-model="milestone.endDate" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12" class="d-flex justify-content-between">
          <b-button type="button" variant="primary" @click="formSubmitted">Submit</b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>

</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import '@/libs/customValidation';

export default {
  name: "AddProject",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      purchaseDate: null,
      currentDate: new Date().toISOString().split('T')[0],
      lifeEndDate: null,
      maintainanceDate: null,
      location: "",
      selected: null,
      costPerHour: 0,
      milestone: {
        name: "",
        description: "",
        startDate: "",
        endDate: "",
      },
      priorityOptions: [
        { value: 'NOTSPECIFIED', text: "Not Specified" },
        { value: 'LOW', text: "Low" },
        { value: 'MEDIUM', text: "Medium" },
        { value: 'HIGH', text: "High" },
      ],
      statusOptions: [
        { value: 'NOTSTARTED', text: "Not Started" },
        { value: 'INPROGRESS', text: "In Progress" },
        { value: 'ONHOLD', text: "On Hold" },
        { value: 'COMPLETED', text: "Completed" },
      ],

      assignee_options: [],
    };
  },

  methods: {
    ...mapActions("projectModule", ["addProjectMilestoneAction", "addProjectTaskAction"]),

    async formSubmitted() {
      let isValid = await this.$refs.AddForm.validate();
      if(isValid){
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the milestone is being added',
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      let payload = {
        projectId: this.$route.params.id,
        ...this.milestone,
        // if start date and end date null, send null
        startDate: this.milestone.startDate ? new Date(this.milestone.startDate).toISOString() : null,
        endDate: this.milestone.endDate ? new Date(this.milestone.endDate).toISOString() : null,
      };
      this.addProjectMilestoneAction(payload).then(() => {
        loader.close();
        this.success();

      }).catch(error => {
        loader.close();
        this.error(error.response.data);
      });
    }
    },
    success() {
      this.$swal({
        title: 'Milestone Added!',
        text: 'You have successfully added the Milestone!',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$emit('milestoneAdded');
        }
      })
    },
    error(data) {
      this.$swal('Error!', this.getErrorString(data) || 'Failed!', 'error');
    },
    getErrorString(data) {
      let msg = "";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop].toString().replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    }
  },

  computed: {
    ...mapGetters("projectModule", {
      loading: "loading",
    }),
  },


};
</script>
